import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';
import { CompilaQuestionarioWrapperImpatti } from './CompilaQuestionarioWrapperImpatti.js';
/*
import { csvcSoggettiListV1 } from '../components-csvc-one/testSoggettiList.js';
function nomeEsteso(key) {
    const pair = csvcSoggettiListV1.find(pair => pair.id === key);
    return pair ? pair.nome.toUpperCase() : null;
}
*/
import  { useSelector } from 'react-redux'
function nomeEsteso(key) {
    const questionarioCorrente = useSelector((state) => state.questCorrente);
    // Estraggo Array stakeholders filtrato
    // const excludedIds = ['AZ', 'CT'];
    // const stakeholdersFiltered = questionarioCorrente.stakeholders.filter(stakeholder => !excludedIds.includes(stakeholder.id));
    const pair = questionarioCorrente.stakeholders.find(pair => pair.id === key);
    return pair ? pair.alias.toUpperCase() : null;
}

export const CompilaQuestionarioRicadute = (props) => {

  return (
    <>
        {props.ricadute.map((ricaduta) => (<>
            <Card key={ricaduta.key} className="bg-100 shadow-none border mb-3" style={{marginBottom:"2%"}}>
                <Card.Body>
                    <Card.Title style={{marginBottom:"3%"}}>
                        <h6 className="text-primary fs-10 mb-0"> <span className="text-info fw-medium">Ricaduta <strong>{ricaduta.codiceCsvc}</strong> :</span> <strong>{ricaduta.effetto}</strong> <span className="text-info fw-medium"><i>({ricaduta.tipo})</i></span><br />
                        <span className="text-info fw-medium">Stakeholders coinvolti [ESRS: {ricaduta.stakeholdersImpattatiCategoriaEsrs}] :</span> {
                        ricaduta.stakeholdersImpattati.map((singleStakeholder) => (<span key="{singleStakeholder}">{nomeEsteso(singleStakeholder)}&nbsp;</span>))}</h6>
                    </Card.Title>
                    <Card.Text>
                        <CompilaQuestionarioWrapperImpatti ricaduta={ricaduta} impatti={ricaduta.impatti} />
                    </Card.Text>
                </Card.Body>
            </Card> 
            <br />
        </>))}
    </>
  );
};

CompilaQuestionarioRicadute.propTypes = {
    ricadute: PropTypes.array.isRequired
};
